import { type ReactNode } from "react";

import circularBackground from "@/assets/images/circular-lines.png";
import FeatureIcon from "@/components/helpers/FeatureIcon";

export default function RequestStatusState({
  color,
  icon,
  title,
  description,
}: {
  color: "success" | "primary" | "warning" | "error";
  icon: ReactNode;
  title: string;
  description?: string;
}) {
  return (
    <div className="flex flex-1 items-center justify-center">
      <div className="flex w-full max-w-lg flex-col items-center">
        <div className="relative flex size-72 items-center justify-center sm:size-80">
          <img
            src={circularBackground}
            alt=""
            className="absolute inset-0 size-full object-contain"
          />
          <FeatureIcon
            color={color}
            variant="outline"
            size="xl"
            className="relative z-10 m-0 flex items-center justify-center"
          >
            {icon}
          </FeatureIcon>
        </div>
        <div className="relative z-10 -mt-16 flex flex-col items-center gap-1 text-center">
          <p className="text-lg font-semibold text-gray-900">{title}</p>
          {description ? (
            <p className="text-sm text-gray-600">{description}</p>
          ) : null}
        </div>
      </div>
    </div>
  );
}
